<div class="modal-wrapper" [ngClass]="modalContext?.customClass">
    <div class="header-wrapper" [class.has-close-button]="modalContext?.showCloseButton">
        <div class="title-wrapper">
            @if(modalContext?.isAlert){
                <div class="icon-wrapper">
                    <cwo-icon class="icon" [name]="iconNameType.warning"/>
                </div>
            }
            <span class="title">{{modalContext?.modalTitle}}</span>
        </div>
        @if(modalContext?.showCloseButton){
            <button class="button-undecorated" (click)="closeModal()" [ariaLabel]="'Close Modal'">
                <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
            </button>
        }
    </div>
    
    @if (modalContext?.modalMessage) {
        <span class="message" [innerHTML]="modalContext?.modalMessage">{{modalContext?.modalMessage}}</span>
    }
    
    @if (modalContext?.messageParts) {
        <div class="message">
            <div class="message-line">{{modalContext?.messageParts?.beforeLink}}</div>
            <div class="message-line">
                <span 
                    class="sign-up-link" 
                    tabindex="0"
                    role="button"
                    [attr.aria-label]="modalContext?.messageParts?.linkText"
                    (click)="handleLinkClick()"
                    (keyup.enter)="handleLinkClick()"
                    (keyup.space)="handleLinkClick()">
                    {{modalContext?.messageParts?.linkText}}
                </span>
                <span>{{modalContext?.messageParts?.afterLink}}</span>
            </div>
        </div>
    }
    
    @if (modalContext?.modalContent){
        <ng-container [ngTemplateOutlet]="modalContext?.modalContent ?? null"></ng-container>
    }
    
    
    <div class="action-buttons-wrapper">
        <div class="divider"></div>
        <button class="button-accent action-button" (click)="confirmAction()">{{modalContext?.confirmButtonText}}</button>
        @if(modalContext?.secondaryAction){
            <button class="button-no-thanks action-button " (click)="secondaryAction()">{{modalContext?.cancelButtonText}}</button>
        }
    </div>
</div>
